export default __webpack_public_path__ + "static/media/AlexK1.505c390d.png";